import {CmnComp} from "../../common/CmnComp"
import section03Styles from "./section03.module.css"

const data = {
	title: "",
	header: "Our Story",
	description:
		`The name Yi Nian Bazi (一念八字) reflects a profound belief: \n “A single thought can change everything.”  Life is dynamic, and while Bazi offers a glimpse of your inherent tendencies, it does not confine you to a predetermined path. Your destiny is shaped by your choices, actions, and mindset.`,
	button: "Read More",
}

export const Section03 = () => {
	return (
		<section id="3" className={section03Styles.section03}>
			<div>
				<CmnComp props={data} />
			</div>
			<div>
				<img
					src="./Images/section_3_1.jpg"
					alt="section03"
				/>
			</div>
		</section>
	)
}
